<div class="flex flex-col md:flex-row px-4 py-2 md:p-4">
    <div class="flex flex-col items-center md:items-start mb-4 mt-4 md:mt-0">
        <div class="flex flex-col items-center">
            <div class="w-32 h-32 md:h-64 md:w-64 rounded overflow-hidden">
                <img *ngIf="release?.artwork" [alt]="'Release artwork'"
                    [src]="platformService.getFileSrc(release?.artwork, 'artwork')"
                    class="col-span-3 w-full h-full object-contain">
            </div>
        </div>
    </div>

    <div class="flex flex-auto flex-wrap md:ml-6 mb-4 justify-between">
        <div class="md:gap-6">
            <div class="text-3xl font-medium">{{release.title}}
            </div>
            <span class="text-xl">{{getArtistNames(getArtists(release)) ?? "No artists assigned"}}</span>
            <span *ngIf="getFeatArtists(release).length > 0" class="text-xl">&nbsp;feat.
                {{getArtistNames(getFeatArtists(release))}}
            </span>
            <div class="grid mt-4 leading-6">
                <div class="grid summary-grid">
                    <div class="colon-after">{{'music-label' | transloco}}</div>
                    <div>{{release.label?.title ?? ''}}</div>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'metadata-language' | transloco}}</div>
                    <div *ngIf="release.language?.alpha3; else noLanguage">
                        {{"lang." + release.language.alpha3 | transloco}}</div>
                    <ng-template #noLanguage>
                        <div>{{'not-set' | transloco}}</div>
                    </ng-template>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'audio-language' | transloco}}</div>
                    <div *ngIf="release.audioLanguage && release.audioLanguage !== '0'; else noAudioLanguage">
                        {{"lang." + release.audioLanguage.alpha3 | transloco}}</div>
                    <ng-template #noAudioLanguage>
                        <div>{{'no-linguistic-content' | transloco}}</div>
                    </ng-template>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'genre' | transloco}}</div>
                    <div>{{getGenreNames(release.primaryGenre, release.subGenre)}}</div>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'release-date' | transloco}}</div>
                    <div>{{release.releaseDate | date}}</div>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'upc-or-ean-code' | transloco}}</div>
                    <div [ngClass]="{'text-hint': !release.ean?.length}">
                        {{!!release.ean?.length ?
                        release.ean :
                        ('ean-will-be-assigned' | transloco)}}
                    </div>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'copyright' | transloco}}</div>
                    <div>&copy;{{release.copyrightYear}}
                        {{release.copyrightText}}</div>
                </div>
            </div>
        </div>
        <div class="flex flex-col gap-3 w-full md:w-auto mt-4 md:mt-0">
            <!-- <button mat-stroked-button type="submit">
                    <mat-icon
                        class="icon-size-5"
                        color="primary"
                        [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
                        <span class="ml-2">Edit</span>
            </button> -->
            <button mat-stroked-button (click)="goToAnalytics()">
                <mat-icon class="icon-size-5" color="primary" [svgIcon]="'heroicons_outline:chart-bar'"></mat-icon>
                <span class="ml-2">{{'analytics-page-title' | transloco}}</span>
            </button>

            <!-- <button mat-stroked-button>
                <mat-icon
                    class="icon-size-5"
                    color="primary"
                    [svgIcon]="'heroicons_outline:link'"></mat-icon>
                <span class="ml-2">Smartlink</span>
            </button> -->
        </div>
    </div>
</div>

<div class="text-xl w-full p-2 px-4 mb-2 border-gray-300">{{('tracklist' | transloco)}}</div>
<mat-accordion id="track-summary-accordion">
    <mat-expansion-panel *ngFor="let track of release?.tracks; let i = index;" [expanded]="release?.tracks.length === 1"
        class="track-summary-panel rounded-md">
        <mat-expansion-panel-header class="h-16 px-6 py-4">
            <mat-panel-title class="justify-between">
                {{i + 1}}. {{track.title}}<span *ngIf="track.version">&nbsp;({{track.version}})</span>
                <div class="flex items-center button-bar ml-auto justify-self-end space-x-3 mr-3">
                    <mat-icon (click)="playTrack($event, track)" [color]="'primary'" [svgIcon]="'heroicons_solid:play'"
                        class="hidden sm:inline-flex icon-size-7 cursor-pointer"
                        matTooltip="{{('play-track-tooltip' | transloco)}}"></mat-icon>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="grid grid-cols-1 md:grid-cols-2">
            <div class="grid leading-6">
                <div class="grid summary-grid">
                    <div class="colon-after">{{'artist-optional-plural' | transloco}}</div>
                    <div>{{getTrackArtistNames(track.participants)}}</div>
                </div>
                <div *ngIf="getOtherTrackParticipants(track.participants) !== ''" class="grid summary-grid">
                    <div class="colon-after">{{'participant-optional-plural' | transloco}}</div>
                    <div>{{getOtherTrackParticipants(track.participants)}}</div>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'genre-optional-plural' | transloco}}</div>
                    <div>{{getGenreNames(track.primaryGenre, track.subGenre)}}</div>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'language' | transloco}}</div>
                    <div *ngIf="track.language && track.language !== '0'; else noTrackLanguage;">{{"lang." +
                        track.language?.alpha3 | transloco}}</div>
                    <ng-template #noTrackLanguage>
                        <div>{{'no-linguistic-content' | transloco}}</div>
                    </ng-template>
                </div>
                <div *ngIf="track.composer" class="grid summary-grid">
                    <div class="colon-after">{{'composer' | transloco}}</div>
                    <div>{{track.composer}}</div>
                </div>
                <div *ngIf="track.songwriter" class="grid summary-grid">
                    <div class="colon-after">{{'songwriter' | transloco}}</div>
                    <div>{{track.songwriter}}</div>
                </div>
                <div *ngIf="track.isrc" class="grid summary-grid">
                    <div class="colon-after">{{'isrc' | transloco}}</div>
                    <div>{{track.isrc}}</div>
                </div>
                <div *ngIf="track.iswc" class="grid summary-grid">
                    <div class="colon-after">{{'iswc' | transloco}}</div>
                    <div>{{track.iswc}}</div>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'explicit' | transloco}}</div>
                    <div>{{track.explicit ? ('yes' | transloco) : ('no' | transloco)}}</div>
                </div>
            </div>
            <div class="grid leading-6">
                <div class="grid summary-grid">
                    <div class="colon-after">{{'duration' | transloco}}</div>
                    <div>{{track.audioFile?.duration | duration}}</div>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'format' | transloco}}</div>
                    <div>{{track.audioFile?.codec ? track.audioFile.codec : ('unknown' | transloco)}}</div>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'bitrate' | transloco}}</div>
                    <div>{{track.audioFile?.bitRate / 1000 | number: '1.0-1'}} kbps</div>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'sample-rate' | transloco}}</div>
                    <div>{{track.audioFile?.samplingRate / 1000 | number: '1.0-1'}} kHz</div>
                </div>
                <div class="grid summary-grid">
                    <div class="colon-after">{{'bit-depth' | transloco}}</div>
                    <div>{{track.audioFile?.lossless ? track.audioFile.bitDepth + " bit" :
                        ("bit-depth-not-applicable" | transloco)}}</div>
                </div>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>
